@if (!disabled) {
  <div cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <div class="vitamui-input editable-field" [class.edit-mode]="editMode" (click)="enterEditMode()">
      <div class="editable-field-content">
        <label>{{ label }}</label>
        <span class="editable-field-text-content">
          @for (domain of control.value; track domain) {
            <div>
              {{ domain }}
              @if (domain === defaultDomain) {
                {{ 'SHARED.DOMAIN_INPUT.DEFAULT_DOMAIN' | translate }}
              }
            </div>
          }
        </span>
        <div class="editable-field-control" [ngStyle]="{ 'margin-top': label ? '15px' : '0' }">
          <app-domains-input
            [style.width.%]="100"
            [formControl]="control"
            [(selected)]="selected"
            [placeholder]="'CUSTOMER.INFORMATIONS.MODAL.DOMAINS_PLACEHOLDER' | translate"
            [spinnerDiameter]="18"
            (click)="onDomainInputClick()"
          ></app-domains-input>
        </div>
      </div>
      @if (!showSpinner && !editMode) {
        <i class="material-icons edit-icon">edit</i>
      }
      @if (showSpinner) {
        <div>
          <mat-spinner class="vitamui-spinner small"></mat-spinner>
        </div>
      }
    </div>
  </div>
  <div class="vitamui-input-errors"></div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="editMode"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="positions"
  >
    <div class="editable-field-actions">
      <button type="button" class="editable-field-confirm" (click)="confirm()" [disabled]="!canConfirm">
        <i class="material-icons">check</i>
      </button>
      <button type="button" class="editable-field-cancel" (click)="cancel()"><i class="material-icons">clear</i></button>
    </div>
  </ng-template>
}

@if (disabled) {
  <div class="read-only-field disabled-input">
    <label>{{ label }}</label>
    @for (domain of control?.value; track domain) {
      <div>
        {{ domain }}
        @if (domain === defaultDomain) {
          {{ 'SHARED.DOMAIN_INPUT.DEFAULT_DOMAIN' | translate }}
        }
      </div>
    }
  </div>
}
